import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService } from "../shared/services/app.service";
import { BaseService } from "../shared/services/base.service";


@Pipe({
    name: 'address',
    standalone: false
})
export class AddressPipe implements PipeTransform {
  constructor(private appService: AppService) { }

  transform(item: any,type?:string){
   if(item != undefined){
    var type = (type == 'primary')?'primary_address':(type == 'secondary')?'secondary_address':type;
    var address = (type != undefined) ? (item[type] != undefined)?item[type]:{}:item['primary_address'];
    return this.appService.getAddressString(address);
   }
   return "";
  }
}


@Pipe({
    name: 'facility_obj',
    standalone: false
})
  export class FacilityObjPipe implements PipeTransform {
    constructor(private baseService: BaseService) { }
  
    transform(faclity_id: any){
     if(faclity_id != undefined){
      return this.baseService.getFaclityObj(faclity_id);
     }
     return "";
    }
  
  }

  @Pipe({
    name: 'property',
    standalone: false
})
  export class PropertyPipe implements PipeTransform {
    constructor() { }
  
    transform(item: any,key:any){
     if(item[key] != undefined){
      return item[key];
     }
     return "";
    }
  
  }